window.addEventListener("FormClientRendered", () => {
    const expertEl = document.querySelector(".expert");
    if (!expertEl) return;

    const formSteps = document.querySelectorAll(".Step");

    formSteps.forEach((step) => {
        const stepHeader = step.querySelector(".StepHeader");
        if (!stepHeader) return;

        const expertClone = expertEl.cloneNode(true);
        stepHeader.prepend(expertClone);
    });
});
